<div class="wrapper">
    <div class="margin-medium">{{ 'research.login.error.lack.privileges' | translate }}</div>
    <button mat-raised-button color="accent" class="is-large margin-medium" espLogout>
        {{ 'research.login.error.back.to.login' | translate }}
    </button>
</div>
